var _defs, _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIconUploadImage = function SvgIconUploadImage(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-7839b9b5-8ab5-4af8-9fd3-e51e1d6f7d89",
    xmlns: "http://www.w3.org/2000/svg",
    width: 50.92,
    height: 50.36,
    viewBox: "0 0 50.92 50.36",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .uuid-de8c9c18-e7f3-4332-ad6a-9c3a396f3157{fill:#393939;isolation:isolate;opacity:.6;}.uuid-de8c9c18-e7f3-4332-ad6a-9c3a396f3157,.uuid-9defdccd-402c-41e9-a578-cb5d50dce048{stroke-width:0px;}.uuid-9defdccd-402c-41e9-a578-cb5d50dce048{fill:#fff;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "uuid-45c7ce19-9b4e-453e-8942-0915b26db4dc",
    className: "uuid-de8c9c18-e7f3-4332-ad6a-9c3a396f3157",
    cx: 25.46,
    cy: 25.18,
    r: 25
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "uuid-c1d11c51-8437-4171-8b0d-aa7a33cb4b3f",
    className: "uuid-9defdccd-402c-41e9-a578-cb5d50dce048",
    d: "M36.48,17.48c-.45-.43-1.15-.43-1.6,0l-13.6,13.07-5.23-5.02c-.45-.43-1.15-.43-1.61,0-.43.4-.45,1.07-.04,1.5.01.01.03.03.04.04l6.03,5.8c.45.43,1.15.43,1.61,0l14.4-13.85c.43-.4.45-1.07.04-1.5-.01-.01-.03-.03-.04-.04Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIconUploadImage);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "icon-uploadImage.26f459c3eb87914f238812dfa44446c8.svg";